'use strict'
import {
  escapeHtml,
  escapeHtmlBr,
  extractionrAreaCodeData,
  getParam
} from '../utilities/index'

export default class player {
  constructor(pagetype) {
    this.playerEl = document.querySelector('.js-player')
    this.playerData = extractionrAreaCodeData('08', window.LIVESTATION.MAINCONTENT)[0]
    this.playerId = escapeHtml(this.playerData.store_name)
    this.coverPath = escapeHtml(this.playerData.remarks)
    this.pagetype = pagetype
    this.init()
  }

  async init() {
    await this.createPlayer()
    await this.settingPlayer()
    /* eslint no-console: 0 */
    console.log('player終わり')
  }

  async createPlayer() {
    const playerId = escapeHtml(this.playerData.store_name)
    const coverPath = this.playerData.remarks
    const title = escapeHtmlBr(this.playerData.store_url.pc)
    const watchBtnText = escapeHtmlBr(this.playerData.free)

    if (!playerId) {
      return
    }

    const castInfoData = extractionrAreaCodeData(
      '01',
      window.LIVESTATION.MAINCONTENT
    )[0]

    const timeText = castInfoData ? escapeHtmlBr(castInfoData.store_url.pc) : ''

    const playerHtml = `
      <div class="playerPcFlex">
        <div class="playerImgWrap js-trackEvent" id="liveshopping-kv-${playerId}" data-label="playerWatchImage">
          <figure class="u-imgAdjustBox playerImgFigure">
            <picture class="u-imgAdjustBox_inner">
              <img class="playerImg fr-img lazyload" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" data-src="${coverPath}" data-expand="300">
            </picture>
          </figure>
        </div>
        <div class="playerInfo">
          <p class="playerTtl">${title}</p>
          <p class="playerTime">${timeText}</p>
          <a class="playerWatchBtn js-trackEvent" id="liveshopping-btn-${playerId}" data-label="playerWatchBtn"><span class="playerWatchBtnInner">${watchBtnText}</span></a>
        </div>
      </div>`

    this.playerEl.innerHTML = playerHtml

    this.attachEventTrack()
  }

  settingPlayer() {
    window.onBambuserLiveShoppingReady = player => {
      player.configure({
        buttons: {
          dismiss: player.BUTTON.MINIMIZE,
          product: player.BUTTON.LINK
        },
        miniplayerSize: player.MINIPLAYER_SIZE.LARGE,
        floatingPlayer: {
          navigationMode: player.FLOATING_PLAYER_NAVIGATION_MODE.MANUAL
        }
      })
    }
      ; (() => {
        window.initBambuserLiveShopping({
          showId: `${this.playerId}`,
          node: document.getElementById(`liveshopping-kv-${this.playerId}`),
          type: 'overlay'
        })
        window.initBambuserLiveShopping({
          showId: `${this.playerId}`,
          node: document.getElementById(`liveshopping-btn-${this.playerId}`),
          type: 'overlay'
        })
        getParam('initPlay') != 'none' &&
          document.body.dataset.initPlay != 'none'
        if (this.pagetype == "pickup") {
          window.initBambuserLiveShopping({
            showId: `${this.playerId}`,
            type: 'overlay'
          })
        }
      })()

    window.addEventListener(
      'bambuser-liveshop-tracking-point',
      ({ detail }) => {
        const bambuserTrackingEvent = detail.event
        const bambuserTrackingData = detail.data
        const bambuserTrackingInteractionType =
          bambuserTrackingData.interactionType

        if (
          (bambuserTrackingEvent === 'on-interaction' &&
            bambuserTrackingInteractionType === 'minimize') ||
          bambuserTrackingInteractionType ===
          'product-highlight:show-product-detail-in-new-tab' ||
          bambuserTrackingInteractionType === 'showAllProductsOverlay' ||
          bambuserTrackingEvent === 'on-load' ||
          bambuserTrackingEvent === 'on-play'
        ) {
          window.dataLayer.push({
            event: 'trackEvent',
            brand: 'UQ',
            eventCategory: `${document.body.dataset.trackEventCategory}_Click`,
            eventAction: 'click',
            eventLabel: (bambuserTrackingEvent === 'on-load' ||
            bambuserTrackingEvent === 'on-play')
              ? `${detail.data.showId}_${bambuserTrackingEvent}`
              : bambuserTrackingInteractionType
          })
        }
      }
    )
  }

  async attachEventTrack() {
    try {
      const items = this.playerEl.querySelectorAll('.js-trackEvent')

      if (!items.length) {
        return
      }

      const { attachEventTrack } = await import(
        /* webpackChunkName: "track" */
        './trackEvent/track'
      )

      attachEventTrack(items)
    } catch (error) {
      /* eslint no-console: 0 */
      console.log(error)
    }
  }
}
